import { useParams } from '@tanstack/react-router';
import { ImportDetailScreen } from '@/features/imports/import-detail-screen';
import { NotFoundPage } from '@/routes/pages/system/not-found';

export function ImportDetailPage() {
  const { importId } = useParams({ strict: false });
  if (!importId) return <NotFoundPage />;
  return <ImportDetailScreen importId={importId} />;
}
